import { lazy } from "react";
import ContactPhoneIcon from "@mui/icons-material/ContactPhone";

import ReportIcon from '@mui/icons-material/Report';
import CategoryIcon from '@mui/icons-material/Category';

const CategoryCreate = lazy(() => import("../components/categoryCreate"));
const CategoryView = lazy(() => import("../components/categoryView"));
const GrievanceCreate = lazy(() => import("../components/grievanceCreate"));
const GrievanceList = lazy(() => import("../components/grievanceList"));
const CategoryList = lazy(() => import("../components/categoryList"));
const GrievanceView = lazy(() => import("../components/grievanceView"));

const grievanceRoute = {
  icon: ContactPhoneIcon,
  name: "Grievance Management",
  link: "/grievance-management",
  path: "/grievance-management",
  index: 40,
  superAdminView: false,

  children: [
    {
      name: "Category",
      permission: "GmsCategory-Read",
      path: "category",
      link: "/grievance-management/category",
      element: <CategoryList />,
      index: 1,
      icon:CategoryIcon
    },
    {
      permission: "GmsCategory-Create",
      path: "category/create",
      link: "/grievance-management/category/create",
      element: <CategoryCreate />,
    },
    {
      path: "category/view/:id",
      link: "/grievance-management/category/view/:id",
      element: <CategoryView />,
    },
    {
      path: "category/:id",
      link: "/grievance-management/category/:id",
      element: <CategoryCreate />,
    },

    {
      name: "Grievance",
      permission: "Grievance-Read",
      path: "grievance",
      link: "/grievance-management/grievance",
      element: <GrievanceList />,
      index: 1,
      icon: ReportIcon,
    },
    {
      permission: "Grievance-Create",
      path: "grievance/create",
      link: "/grievance-management/grievance/create",
      element: <GrievanceCreate />,
    },
    {
      path: "grievance/view/:id",
      link: "/grievance-management/grievance/view/:id",
      element: <GrievanceView />,
    },
    {
      path: "grievance/:id",
      link: "/grievance-management/grievance/:id",
      element: <GrievanceCreate />,
    },
  ],
};

export default grievanceRoute;
